import styled, { keyframes } from 'styled-components';

export const loadAnimation = keyframes`
  from {
    opacity: 0.3;
  }

  to {
    opacity: 0.8;
  }
`;

export const LoadingText = styled.p`
  margin: 0;
  animation: ${loadAnimation} 0.7s linear alternate infinite;
  width: 100%;
  height: 16px;
  background-color: rgba(200, 200, 200, 0.8);
  border-radius: 5px;
`;
